import Cookies from "js-cookie";
import imageCompression from 'browser-image-compression';
import { ApiGetCall, ApiGetCallAuthKey } from "./Connector";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

import { store } from "../Store/Store";
import { log } from "./Logger";

export var LogInUserID = null;
export var LogInSchoolID = null;
export var AdminSchoolId = null;
export var userTimeZone = 'America/New_York'
export var IsEnterprise = false;
// Initial load (in case redux already has data)
const initState = store.getState();
LogInUserID = initState?.authData?.csvUserID;
LogInSchoolID = initState?.authData?.SchoolId;
userTimeZone = initState?.authData?.UserTimeZone;
AdminSchoolId = initState?.authData?.AdminSchoolId;
IsEnterprise = initState?.authData?.isEnterprise || false;
// Auto update on any redux changes
store.subscribe(() => {
  const state = store.getState();
  LogInUserID = state?.authData?.csvUserID;
  LogInSchoolID = state?.authData?.SchoolId;
  userTimeZone = state?.authData?.UserTimeZone;
  AdminSchoolId = state?.authData?.AdminSchoolId;
  const newIsEnterprise = state?.authData?.isEnterprise || false;
  if (IsEnterprise !== newIsEnterprise) {
    IsEnterprise = newIsEnterprise;
  }
});

// Both the parameters are important
export const CustomParseSafeHtml = (htmlString = "", isReact = true) => {
  if (!isReact) {
    const domParser = new DOMParser();
    const doc = domParser.parseFromString(DOMPurify.sanitize(htmlString), "text/html");
    const container = document.createElement("div");
    container.append(...doc.body.childNodes);
    return container;
  }
  return parse(DOMPurify.sanitize(htmlString.replace(/<img /g, "<img class='img-fluid'")));
};

export const origin = window.location.origin;
export const BaseUrl = `${process.env.REACT_APP_Base_URL}/api`;
export const BucketS3Link = `${process.env.REACT_APP_Base_URL}/uploads/`;

const normalizeDateValue = (value) => {
  if (!value && value !== 0) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed || trimmed === "-") return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      const [year, month, day] = trimmed.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    const parsed = new Date(trimmed);
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }

  return null;
};

export function formatDateValue(value, pattern = "MM-DD-YYYY") {
  const date = normalizeDateValue(value);
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  switch (pattern) {
    case "YYYY-MM-DD":
      return `${year}-${month}-${day}`;
    case "YYYY-MM-DD HH:mm:ss":
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    case "MM-DD-YYYY":
    default:
      return `${month}-${day}-${year}`;
  }
}

export function MMDDYYYY(utcDateString) {
  return formatDateValue(utcDateString, "MM-DD-YYYY");
}

export const formatDateToMMDDYYYY = (today) => formatDateValue(today, "MM-DD-YYYY");

export const formatDateToUsaMMDDYYYY = (today) => {
  if (!today) return "-";
  const formatted = formatDateValue(today, "MM-DD-YYYY");
  return formatted || "-";
};

export function YYYYMMDD(date) {
  return formatDateValue(date, "YYYY-MM-DD");
}

export var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

export var organizationName = "school";
export function setSchoolName(name) {
  organizationName = name;
}

export var studentUser = "user";
export function setStudentUser(name) {
  studentUser = name;
}

export var parentGuardianManager = "manager";
export function setParentGuardianManager(name) {
  parentGuardianManager = name;
}

export var parentManager = "manager";
export function setParentManager(name) {
  parentManager = name;
}

export var gradeDepartment = "department";
export function setGradeDepartment(name) {
  gradeDepartment = name;
}

export var dccModuleText = "Device Complete Club";
export function setDccModuleText(name) {
  dccModuleText = name
}

export function transformNameOfCol(nameofcol) {
  if (!nameofcol) return nameofcol;
  if (IsEnterprise) {
    if (new RegExp(dccModuleText, 'i').test(nameofcol)) return null;
  }
  const replacements = [
    { pattern: /student/gi, replacement: studentUser },
    { pattern: /parent guardian/gi, replacement: parentGuardianManager },
    { pattern: /parent(?! guardian)/gi, replacement: parentManager },
    { pattern: /grade/gi, replacement: gradeDepartment },
    { pattern: /school/gi, replacement: organizationName },
  ];
  let updated = nameofcol;
  replacements.forEach(({ pattern, replacement }) => {
    updated = updated.replace(pattern, replacement);
  });
  return updated?.trim();
}

export function revertColNames(nameofcol) {
  const replacements = [
    { pattern: /^Item$/i, replacement: "Title" },
    { pattern: /^Price$/i, replacement: "Variant_Price" },
    { pattern: /^QTY$/i, replacement: "Quantity" },
    { pattern: /^Brand$/i, replacement: "Brand_Name" },
    { pattern: /^(Reminder_QTY|Reminder QTY)$/i, replacement: "Reminder_Quantity" },
    { pattern: /^(Store_URL|Store URL)$/i, replacement: "Handle" },
  ];
  let updated = nameofcol;
  replacements.forEach(({ pattern, replacement }) => {
    updated = updated.replace(pattern, replacement);
  });
  return updated.trim();
}

export function ShowLoder() {
  return (
    <>
      <div className="text-center"><img src="/images/loder.svg" className="LoderImg" style={{ display: "block" }} /></div>
      <div id="Overlay" style={{ display: "block" }}></div>
    </>
  );
}

export function HideLoder() {
  return (
    <>
      <div id="Overlay" style={{ display: "none" }}></div>
      <img src="/images/loder.svg" className="m-auto LoderImg" style={{ display: "none" }} />
    </>
  );
}

export function handleKeyPress(event) {
  const pattern = /^[a-zA-Z0-9]+$/;
  const inputChar = String.fromCharCode(event.charCode);
  if (!pattern.test(inputChar)) {
    event.preventDefault();
  }
}

export const typewatch = (function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export function isValidEmail(email) {
  if (!email) {
    return false; // Email is empty
  }

  const [localPart, domainPart] = email?.trim().split("@");
  if (!domainPart || domainPart.indexOf(".") === -1) {
    return false; // Domain part is missing or does not contain a dot
  }

  const localPartRegex = /^[^@\s]+$/; // Match any character that is not '@' or whitespace
  if (!localPartRegex.test(localPart)) {
    return false; // Local part contains invalid characters or is empty
  }

  const domainPartRegex = /^[A-Za-z0-9.-]+$/; // Match letters, numbers, dots, and hyphens
  if (!domainPartRegex.test(domainPart) || domainPart.length < 2) {
    return false; // Domain part contains invalid characters or is too short
  }

  // Check that the domain part does not contain consecutive periods
  if (domainPart.indexOf("..") !== -1) {
    return false;
  }

  const tldRegex = /^[A-Za-z]{2,}$/; // Match at least two letters for the TLD
  const tld = domainPart.split(".").pop();
  if (!tldRegex.test(tld)) {
    return false; // Invalid TLD
  }
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!pattern.test(email?.trim())) {
    return false;
  }
  return true;
}

export function Camelcase(str) {
  return str?.replace(/(?:^|\s)\w/g, function (match) {
    return match.toUpperCase();
  });
}

export function RemoveAllCookies() {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove('ciphertext');
  Cookies.remove('ShipSchoolName');
}

export function handleUnauthorized(response) {
  if (response.status === 401 || response.status === 419) {
    RemoveAllCookies();
    window.location.href = "/";
    return true;
  }
  return false;
}

export function getTodayDate() {
  return formatDateValue(new Date(), "YYYY-MM-DD");
}

export const quicksort = (arr, key, sortOrder) => {
  if (arr.length <= 1) {
    return arr;
  }

  const pivot = arr[Math.floor(arr.length / 2)];
  const less = arr.filter((item) => item[key] < pivot[key]);
  const equal = arr.filter((item) => item[key] === pivot[key]);
  const greater = arr.filter((item) => item[key] > pivot[key]);

  let sortedArray;
  if (sortOrder === 'asc') {
    sortedArray = [...quicksort(less, key, sortOrder), ...equal, ...quicksort(greater, key, sortOrder)];
  } else {
    sortedArray = [...quicksort(greater, key, sortOrder), ...equal, ...quicksort(less, key, sortOrder)];
  }

  return sortedArray;
};

export const customDates = (qflag) => {
  let startDate, endDate;

  const now = new Date();

  if (qflag === 2) {
    startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
    endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);

  } else if (qflag === 3) {
    const currentQuarter = Math.ceil((now.getMonth() + 1) / 3);
    const startMonth = (currentQuarter - 1) * 3;
    startDate = new Date(now.getFullYear(), startMonth, 1, 0, 0, 0);
    endDate = new Date(now.getFullYear(), startMonth + 2, new Date(now.getFullYear(), startMonth + 2, 0).getDate(), 23, 59, 59);

  } else if (qflag === 4) {
    startDate = new Date(now.getFullYear(), 0, 1, 0, 0, 0);
    endDate = new Date(now.getFullYear(), 11, 31, 23, 59, 59);

  } else if (qflag === 5) {
    startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0);
    endDate = new Date(now.getFullYear(), now.getMonth() - 1, new Date(now.getFullYear(), now.getMonth(), 0).getDate(), 23, 59, 59);

  } else if (qflag === 6) {
    const currentQuarter = Math.ceil((now.getMonth() + 1) / 3);

    let lastQuarter = currentQuarter - 1;
    let year = now.getFullYear();

    if (lastQuarter === 0) {
      lastQuarter = 4;
      year -= 1;
    }

    const startMonth = (lastQuarter - 1) * 3;

    startDate = new Date(year, startMonth, 1, 0, 0, 0);
    endDate = new Date(year, startMonth + 3, 0, 23, 59, 59);
  } else {
    startDate = new Date(now.getFullYear() - 1, 0, 1, 0, 0, 0);
    endDate = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59);
  }
  return { startDate, endDate }
};
export const CamelCaseWithSpaces = (input) => {
  if (/\s/.test(input)) {
    return input?.replace(/\b\w/g, (match) => match.toUpperCase());
  }
  return input.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());
};
export function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const getTypeWatchDelay = (searchString, value) => searchString ? value : 0;

export const parseDateOnly = (dateStr) => {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split(/[-T]/);
  return new Date(+y, +m - 1, +d);
};

export function YYYYMMDD_HHMM(date) {
  const normalized = normalizeDateValue(date);
  if (!normalized) return null;
  return formatDateValue(normalized, "YYYY-MM-DD HH:mm:ss");
}
export const handleCustomSubmit = (customFields, OriginalCustomFields, flag) => {
  const newCustomFieldValues = [];

  customFields.forEach((item, i) => {
    if (item.value && item.value_type != 7) {
      newCustomFieldValues.push({
        CustomFieldValueid: flag == 1 ? null : item.CustomFieldValueid,
        custom_field_id: item.id,
        custom_field_structure_id: null,
        value_type: item.value_type,
        value: item.value
      });
    } else if (item.value_type == 7 && item.value.length != 0) {
      newCustomFieldValues.push({
        CustomFieldValueid: flag == 1 ? null : item.CustomFieldValueid,
        custom_field_id: item.id,
        custom_field_structure_id: item.value,
        value_type: item.value_type,
        value: item.value,
      });
    } else if (flag == 2 && (OriginalCustomFields[i].value != "" && OriginalCustomFields[i].value != null) && (item.value == null || item.value == "" || isNaN(item.value))) {
      newCustomFieldValues.push({
        CustomFieldValueid: item.CustomFieldValueid,
        custom_field_id: item.id,
        custom_field_structure_id: null,
        value_type: item.value_type,
        value: null,
      });
    }
  });
  return newCustomFieldValues;
};

export const getAllGrades = async (setGrades) => {
  var sclid = (LogInSchoolID && LogInSchoolID != 0) ? LogInSchoolID : 0;
  var gradeParams = AdminSchoolId ? AdminSchoolId : sclid;
  await ApiGetCall(`/schools/grades?schoolId=${gradeParams}`).then((result) => {
    if (result == undefined || result == "") {
      alert("Something went wrong");
    } else {
      const responseRs = JSON.parse(result);
      const FilterEmpty = responseRs?.filter(item => item?.trim() != "");
      setGrades(FilterEmpty);
    }
  });
}

export const GetBuildingGrade = async ({ setGradeArray, setBuildingArray }) => {

  const controller = new AbortController();
  const signal = controller.signal;

  await ApiGetCallAuthKey(`/allocations/grades-buildings?schoolId=${LogInSchoolID}`, signal).then((result) => {
    if (result == undefined || result == "") {
      log.error("Something Went Wrong");
    } else {
      const responseRs = JSON.parse(result);
      if (responseRs.response == "success") {
        const sortedGradeArray = responseRs?.grade
          ?.filter(item => item?.grade?.trim() != "")
          ?.sort((a, b) =>
            a?.grade?.localeCompare(b?.grade)
          );

        const sortedBuildingArray = responseRs?.building
          ?.filter(item => item?.building?.trim() != "")
          ?.sort((a, b) =>
            a?.building?.localeCompare(b?.building)
          );

        if (setGradeArray) setGradeArray(sortedGradeArray);
        if (setBuildingArray) setBuildingArray(sortedBuildingArray);
      }
    }
  });
}

export const GetAllSchoolsByLocation = async ({ setLocations, setSchoolFilterData, setAllSchool }) => {
  await ApiGetCallAuthKey("/schools/by-location").then((result) => {
    if (result == undefined || result == "") {
      alert("Something went wrong");
    } else {
      const responseRs = JSON.parse(result);
      if (responseRs?.all_location?.length != 0) {
        const sortedLocations = responseRs.all_location
          ?.filter(item => item?.location_name && item?.location_name?.trim() != "")
          ?.sort((a, b) =>
            a?.location_name?.localeCompare(b?.location_name)
          );

        const sortedSchools = responseRs.all_school
          ?.filter(item => item?.name && item?.name?.trim() != "")
          ?.sort((a, b) =>
            a?.name?.localeCompare(b?.name)
          );

        if (setLocations) setLocations(sortedLocations);
        if (setSchoolFilterData) setSchoolFilterData(sortedSchools);
        if (setAllSchool) setAllSchool(sortedSchools);
      }
    }
  });
}

export const getpostalcodes = async (setallstate) => {
  await ApiGetCall("/shipping/postal-codes").then((result) => {
    if (result == undefined || result == "") {
      alert("Something went wrong");
    } else {
      const responseRs = JSON.parse(result);
      const sortedStates = responseRs.sort((a, b) => a.name.localeCompare(b.name))
      setallstate(sortedStates);
    }
  });
}

export const getAllBuildings = async (setallbuilding, schoolid) => {
  let sId = schoolid || null
  await ApiGetCallAuthKey(`/buildings/with-rooms?schoolId=${sId}`).then((result) => {
    if (result == undefined || result == "") {
      alert("Something went wrong");
    } else {
      const responseRs = JSON.parse(result);
      responseRs.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      setallbuilding(responseRs);
    }
  });
}

export const getAllUsers = async (setAllUsers) => {
  await ApiGetCall(`/users/all?schoolId=${LogInSchoolID}&userId=${LogInUserID}`).then((result) => {
    if (result == undefined || result == "") {
      alert("Something went wrong");
    } else {
      const responseRs = JSON.parse(result);
      if (responseRs?.status == 'error') {
        setAllUsers([]);
        return;
      }
      if (responseRs?.msg?.length) {
        const sortedUsers = responseRs?.msg?.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setAllUsers(sortedUsers);
      } else {
        setAllUsers([]);
      }
    }
  });
}

export function GetAllGroups({ setLoading, setAllGroups }) {
  ApiGetCall(`/helpdesk/groups-list?schoolId=${LogInSchoolID}`).then((result) => {
    if (result == undefined || result == "") {
      alert("Something went wrong");
    } else {
      if (setLoading) setLoading(false);
      const responseRs = JSON.parse(result);
      if (responseRs?.status == 'error') {
        setAllGroups([]);
        return;
      }
      if (responseRs.length != 0) {
        const sortedGroups = responseRs.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        if (setAllGroups) setAllGroups(sortedGroups);
      }
    }
  });
}

export function trackingHandle(trackingnum) {
  const url = `https://www.fedex.com/fedextrack/?action=track&trackingnumber=${trackingnum}&cntry_code=us&locale=en_us`;
  window.open(url, '_blank');
}

export function shipStationUrlTrack(trackingUrl) {
  window.open(trackingUrl, '_blank');
}


export function scrollToFirstInvalidField(formID) {
  const container = document.getElementById(formID);
  if (!container) return;

  const feedbacks = container.querySelectorAll('.invalid-feedback');
  for (const feedback of feedbacks) {
    if (feedback.offsetParent !== null || getComputedStyle(feedback).display !== 'none') {
      const field = feedback.previousElementSibling;
      const target = field || feedback;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      break;
    }
  }
}

export function generateRandomString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // months are 0-based
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
}


export const getDefaultSchoolYearRange = () => {
  const today = new Date();
  const year = today.getFullYear();
  const start = new Date(today >= new Date(`${year}-07-01`) ? `${year}-07-01` : `${year - 1}-07-01`);
  const end = new Date(start.getFullYear() + 1, 5, 30); // June 30
  return { start, end };
};


export const compressImage = async (file) => {
  let compressedFile = file;
  const maxSizeMB = 1;
  const imageOptions = {
    maxSizeMB,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  }
  if (file.size / 1024 / 1024 > maxSizeMB) {
    const blob = await imageCompression(file, imageOptions);

    compressedFile = new File([blob], file.name, {
      type: file.type,
      lastModified: file.lastModified,
    });
  }
  return compressedFile
}

export function getBatchName(tz) {
  const now = new Date(new Date().toLocaleString("en-US", { timeZone: tz }));
  const date = now.toLocaleDateString("en-CA");
  const time = now.toLocaleTimeString("en-US", { hour12: false }).replace(/:/g, "");
  return `batch_${date}_${time}`;
}

function base64ToBytes(base64) {
  base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
  base64 = base64.replace(/\s+/g, '');

  // Add padding if needed
  while (base64.length % 4 !== 0) {
    base64 += '=';
  }

  return Uint8Array.from(atob(base64), c => c.charCodeAt(0));
}


export async function encryptText(text, base64SecretKey) {
  const enc = new TextEncoder();
  const rawKey = base64ToBytes(base64SecretKey);
  const key = await crypto.subtle.importKey("raw", rawKey, { name: "AES-GCM" }, false, ["encrypt"]);
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    enc.encode(text)
  );
  return btoa(JSON.stringify({
    iv: Array.from(iv),
    data: Array.from(new Uint8Array(encrypted))
  }));
}

export function ymdToDate(ymd) {
  if (!ymd) return null;
  const [y, m, d] = ymd?.split("-");
  return new Date(y, m - 1, d);
}

export const escapeCsv = (value) => {
  if (value == null || value == undefined) return "";
  const str = value.toString();
  if (str.includes(",") || str.includes("\n") || str.includes('"')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const unescapeHtml = (value) => {
  if (value == null) return "";

  return String(value)
    .replace(/&#0?39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
};

export const patchAxisTitles = (categories, chartEl) => {
  if (!chartEl || !categories || !categories.length) return;

  const labels = chartEl?.querySelectorAll(".apexcharts-xaxis-label");
  if (!labels || !labels.length) return;

  labels?.forEach((labelEl, index) => {
    const fullText = categories[index];
    if (!fullText) return;

    let titleEl = labelEl?.querySelector("title");
    if (!titleEl) {
      titleEl = document?.createElementNS("http://www.w3.org/2000/svg", "title");
      labelEl.appendChild(titleEl);
    }

    titleEl.textContent = fullText;
  });
}

export function normalizeToSnakeCase(obj) {
  if (Array.isArray(obj)) return obj.map(normalizeToSnakeCase)

  if (obj && obj.constructor === Object) {
    const result = {}

    Object.entries(obj).forEach(([key, value]) => {
      let snakeKey = key

      if (typeof key === "string") {
        snakeKey = key
          .replace(/([A-Z])/g, '_$1')
          .replace(/([^a-zA-Z0-9])/g, '_$1_')
          .replace(/__+/g, '_')
          .replace(/^_+|_+$/g, '')
          .toLowerCase()
      }

      // Keep customData values untouched
      if (key === 'customData') {
        result[snakeKey] = value
      } else {
        result[snakeKey] = normalizeToSnakeCase(value)
      }
    })

    return result
  }

  return obj
}
export const capitaliseFirstWord = (value = "") =>
  value
    ? value[0].toUpperCase() + value.slice(1).toLowerCase()
    : "";

export function normalizeToSnakeCaseWithSpecialChar(obj) {
  if (Array.isArray(obj)) return obj.map(normalizeToSnakeCaseWithSpecialChar)

  if (obj && obj.constructor === Object) {
    const result = {}

    Object.entries(obj).forEach(([key, value]) => {
      let snakeKey = key

      if (typeof key === "string") {
        if (key.includes('%') && key === key.toLowerCase()) {
          snakeKey = key.replace(/%/g, '_');
        } else {
          snakeKey = key
            .replace(/([A-Z])/g, '_$1')
            .replace(/([^a-zA-Z0-9()&])/g, '_$1_')
            .replace(/__+/g, '_')
            .replace(/^_+|_+$/g, '')
            .toLowerCase();
        }
      }

      result[snakeKey] = normalizeToSnakeCaseWithSpecialChar(value)
    })

    return result
  }

  return obj
}

export const handleSampleCSVDownload = (csvPath, fileName) => {
  fetch(csvPath)
    .then(res => res.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
};

export function resetFormValidationErrors(FormId) {
  const formElement = document.getElementById(FormId);
  if (!formElement) return;
  const invalidFeedbacks = formElement.querySelectorAll('.invalid-feedback');
  invalidFeedbacks.forEach((el) => {
    el.style.display = ''; // reset to default (hidden)
  });
}

export const onPasteRestriction = (e, restrictArray = ['#']) => {
  const pastedText = e.clipboardData.getData('text');
  if (restrictArray.some(char => pastedText.includes(char)) ||
    (pastedText.trim() === "" && !e.target.value)) {
    e.preventDefault();
  }
}

export const onKeyDownRestrict = (e, restrictArray = ['#']) => {
  if (restrictArray.includes(e.key) || (e.key == " " && !e.target.value)) {
    e.preventDefault();
  }
}

export var decimalRange = 2;
export function setDecimalRange(value) {
  decimalRange = value;
}

export const formatDecimal = (value, decimals = decimalRange) => {
  const num = parseFloat(value);
  if (isNaN(num)) return (0).toFixed(decimals);
  return num.toFixed(decimals);
};

export function sanitizeCSVField(key, value, FIELDS_TO_SANITIZE) {
  if (typeof value !== 'string') return value ?? '';
  if (FIELDS_TO_SANITIZE.includes(key)) {
    value = value.replace(/"/g, '""');
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      value = `"${value}"`;
    }
  }
  return value;
}

export function formatPackageType(str) {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function validateFieldLengths(fields) {
  for (const [value, maxLen, errorMsg, minLen = 0] of fields) {
    const str = String(value ?? '');
    if (!str && minLen === 0) continue;
    if (str.length > maxLen || str.length < minLen) {
      return errorMsg;
    }
  }
  return null;
}

export function truncate(value, maxLen = 50) {
  return String(value ?? '').slice(0, maxLen);
}